import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router";
import "../../style/Profil_Edit.css";
import { useProfilStore } from "../../stores/useStore";
import { useState } from "react";

const Edit = observer(() => {
  const navigate = useNavigate();
  const profilStore = useProfilStore();
  const [pseudo, setPseudo] = useState(profilStore.pseudo);
  const [mail, setMail] = useState(profilStore.mail);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const handleConfirm = async (e) => {
    e.preventDefault();
    try {
      await profilStore.editProfil({ newPseudo: pseudo, newMail: mail });
    } catch {}
    navigate("/profil");
  };

  const backProfil = () => {
    navigate("/profil");
  };

  // const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     try {
  //       await profilStore.connect(mail, password);
  //       if (redirectInfo && redirectInfo.reason === "triedPlaying") {
  //         navigate("/play/param");
  //       } else {
  //         navigate("/profil");
  //       }
  //     } catch (error) {
  //       if (error.message === "user-not-found") {
  //         navigate("/sign", { state: { mail } });
  //       } else if (error.message === "wrong-password") {
  //         alert("Mot de passe incorrect !");
  //       } else {
  //         alert("Erreur inconnue : " + error.message);
  //       }
  //     }
  //   };

  return (
    <form onSubmit={handleConfirm} className="profil_edit_content">
      <h2 className="profil_edit_title">Modifier les informations du profil</h2>
      <div className="profil_edit_pseudoDiv">
        <input
          className="profil_edit_pseudoInput"
          id="profil_edit_pseudoInput"
          type="text"
          value={pseudo}
          onChange={(e) => setPseudo(e.target.value)}
          placeholder="Xxx_DarkFire95_xxX"
        />
        <label
          htmlFor="profil_edit_pseudoInput"
          className="profil_edit_pseudoLabel"
        >
          Nouveau Pseudo
        </label>
      </div>
      <div className="profil_edit_mailDiv">
        <input
          className="profil_edit_mailInput"
          id="profil_edit_mailInput"
          type="email"
          value={mail}
          onChange={(e) => setMail(e.target.value)}
          placeholder="adresse@mail.com"
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
        />
        <label
          htmlFor="profil_edit_mailInput"
          className="profil_edit_mailLabel"
        >
          Nouveau Mail
        </label>
      </div>
      {/* <div className="profil_edit_passwordDiv">
        <input
          className="profil_edit_passwordInput"
          id="profil_edit_passwordInput"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe Ici"
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
        />
        <label
          htmlFor="profil_edit_passwordInput"
          className="profil_edit_passwordLabel"
        >
          Nouveau Mot de Passe
        </label>
      </div> */}
      <div className="profil_edit_buttonList">
        <button
          type="button"
          onClick={backProfil}
          className="profil_edit_discardChange"
        >
          Annuler
        </button>
        <button type="submit" className="profil_edit_confirmChange">
          Confirmer
        </button>
      </div>
    </form>
  );
});

export default Edit;
